var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
// import { UtilityNav } from '../utilityNav';
import { Meganav } from '../meganav';
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.scrollBarExists = false;
        _this.heightListener = document.getElementById("heightChangeListener");
        _this.handleClick = function (event) {
            // console.log("we clicked");
            // var myElement = this.searchRef;
            var myElement = document.getElementById("searchWrapper");
            // var buttonElement = this.searchButtonRef;
            var buttonElement = document.getElementById("toggleSearch");
            var mobileElement = document.getElementById("toggleMobile");
            // console.log("myElement:");
            // console.log(myElement);
            // if( myElement.contains(event.target) || buttonElement.contains(event.target) || event.target.classList.contains("ms-Icon--Cancel") || event.target.classList.contains("cancel-button")){
            if (myElement.contains(event.target) || event.target.classList.contains("ms-Icon--Cancel") || event.target.classList.contains("cancel-button")) {
                // console.log("clicked inside");
                // the click is inside so continue to whatever we were doing before
                return;
            }
            if (mobileElement.contains(event.target)) {
                _this.navToggleClick(event);
            }
            // the click is outside, do something
            // console.log("clicked outside");
            if (_this.state.searchVisible) {
                _this.searchToggleClick(event);
            }
            else {
                if (buttonElement.contains(event.target)) {
                    _this.searchToggleClick(event);
                }
            }
        };
        _this.markScroll = function () {
            var pageTall = document.getElementById("s4-workspace").scrollHeight > document.getElementById("s4-workspace").clientHeight;
            var pageCanScroll = window.getComputedStyle(document.getElementById("s4-workspace")).overflowY == "auto"; // not "hidden"
            // console.log("pageTall: " + pageTall);
            // console.log("pageCanScroll: " + pageCanScroll);
            if (pageTall && pageCanScroll) {
                document.querySelector("HTML").classList.add("scrollbar-visible");
                _this.scrollBarExists = true;
                // calculate scrollbar width
                _this.scrollBarWidth = _this.utils ? _this.utils.findScrollbarWidth() : 0;
                // console.log("scrollBarWidth: " + this.scrollBarWidth);
            }
            else {
                document.querySelector("HTML").classList.remove("scrollbar-visible");
                _this.scrollBarExists = false;
                _this.scrollBarWidth = 0;
            }
        };
        _this.markRibbon = function (load) {
            if (load && document.getElementById("ms-designer-ribbon") != null) {
                if (document.getElementById("ms-designer-ribbon").clientHeight > 0) {
                    document.querySelector("HTML").classList.add("ribbon-exists");
                }
                else {
                    document.querySelector("HTML").classList.add("no-ribbon");
                }
            }
            else {
                document.querySelector("HTML").classList.remove("ribbon-exists");
                document.querySelector("HTML").classList.remove("no-ribbon");
            }
        };
        // private hideHeader = () => {
        //     let navBarHeight: number = this.state.isTablet ? 60 : 142;
        //     let lastScrollTop: number = 0;
        //     const delta: number = 5;
        //     document.getElementById('s4-workspace').addEventListener('scroll', () =>{
        //         let scrolledAmount: number = document.getElementById('s4-workspace').scrollTop;
        //         let toggleCondition: boolean = (this.state.isTablet && scrolledAmount > 60) || (!this.state.isTablet && scrolledAmount > 142) ? true: false;
        //         // console.log("scrolledAmount: " + scrolledAmount);
        //         if( toggleCondition){
        //             scrolledAmount = document.getElementById('s4-workspace').scrollTop;
        //             if( Math.abs(lastScrollTop - scrolledAmount) <= delta ){
        //                 return;
        //             }
        //             // console.log("lastScrollTop: " + lastScrollTop);
        //             if( scrolledAmount > lastScrollTop && scrolledAmount > navBarHeight){
        //                 // console.log("here 1");
        //                 document.getElementById("mainHeader").classList.add("scrolledUp");
        //             } else {
        //                 if( scrolledAmount < lastScrollTop && scrolledAmount > navBarHeight){
        //                     // console.log("here 2");
        //                     if(document.getElementById("mainHeader").classList.contains("scrolledUp") ){
        //                         document.getElementById("mainHeader").classList.remove("scrolledUp");
        //                     }
        //                 }
        //             }
        //             lastScrollTop = scrolledAmount;
        //         }
        //     })
        // }
        _this.navToggleClick = function (e) {
            // console.log("inside navToggleClick");
            e.preventDefault();
            e.stopPropagation();
            if (_this.state.searchVisible) {
                // close search if visible
                _this.searchToggleClick(e);
            }
            _this.setState({
                meganavOpen: !_this.state.meganavOpen
            }, function () {
                // keep body from scrolling
                // document.getElementById("s4-workspace").classList.toggle("noScroll");
            });
        };
        _this.searchToggleClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.state.meganavOpen) {
                // console.log("close the meganav");
                // close meganav if visible
                _this.navToggleClick(e);
            }
            _this.setState({
                searchVisible: !_this.state.searchVisible
            }, function () {
                // keep body from scrolling
                // document.getElementById("s4-workspace").classList.toggle("noScroll");
                // if the search toggle was closed, bring the focus back to itself
                var searchButton = document.getElementById("toggleSearch");
                var searchWrapper = document.getElementById("searchWrapper");
                if (!_this.state.searchVisible) {
                    searchButton.focus();
                    searchButton.classList.remove("close");
                    searchWrapper.classList.add("hide");
                    searchWrapper.classList.remove("show");
                    _this.setSearchTabIndex("-1");
                }
                else {
                    searchButton.classList.add("close");
                    searchWrapper.classList.remove("hide");
                    searchWrapper.classList.add("show");
                    _this.setSearchTabIndex("0");
                }
            });
        };
        _this.setWorkspaceSize = function () {
            console.debug("setWorkspaceSize: FixRibbonAndWorkspaceDimensions / s4-workspace", window["FixRibbonAndWorkspaceDimensions"], document.getElementById("s4-workspace").style.height.length);
            if (!window["FixRibbonAndWorkspaceDimensions"] || document.getElementById("s4-workspace").style.height.length == 0) {
                // console.log("need to setWorkspaceSize");
                // document.getElementById("s4-workspace").style.height = window.innerHeight + 'px';
                // document.getElementById("s4-workspace").style.width = window.innerWidth + 'px';
                document.getElementById("s4-workspace").style.height = document.documentElement.clientHeight + 'px';
                document.getElementById("s4-workspace").style.width = document.documentElement.clientWidth + 'px';
            }
        };
        _this.state = {
            meganavOpen: false,
            searchVisible: false,
            scopeOpen: false,
            searchUrl: "",
            sliderFirstHidden: false,
            sliderSecondHidden: false,
            // all the snippets
            headerLogo: null,
            navToggleAltText: "",
            searchToggleAltText: ""
        };
        _this.onComponentResize = _this.onComponentResize.bind(_this);
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var SnippetHelper, Utils, delayResizeEvent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // set s4-workspace size
                        this.setWorkspaceSize();
                        this._isMounted = true;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: 'helpers' */
                            '@pm-tt/common-components/lib/SnippetHelper')];
                    case 1:
                        SnippetHelper = (_a.sent()).SnippetHelper;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: 'helpers' */
                            '@pm-tt/common-components/lib/Utils')];
                    case 2:
                        Utils = (_a.sent()).Utils;
                        this.snippetHelper = SnippetHelper;
                        this.utils = Utils;
                        this.markRibbon(true);
                        // put the getsnippet in here
                        // this.snippetHelper.getSnippet("#headerLogo").then( snippet => {
                        //     // set snippet to state
                        //     if( snippet.length > 0 && this._isMounted){
                        //         this.setState({
                        //             headerLogo: snippet[0]
                        //         });
                        //     }
                        // });
                        this.snippetHelper.getSnippet("#headerLogoAlt").then(function (snippet) {
                            // set snippet to state
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({
                                    headerLogo: snippet[0].snippet
                                }, function () {
                                    if (_this.state.headerLogo) {
                                        document.getElementById("headerLogoImg").setAttribute("alt", _this.state.headerLogo);
                                    }
                                });
                            }
                        });
                        this.snippetHelper.getSnippet("#toggleMobile").then(function (snippet) {
                            // set snippet to state
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({
                                    navToggleAltText: snippet[0].snippet
                                }, function () {
                                    document.getElementById("toggleMobileLabel").innerHTML = _this.state.navToggleAltText;
                                });
                            }
                        });
                        this.snippetHelper.getSnippet("#toggleSearch").then(function (snippet) {
                            // set snippet to state
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({
                                    searchToggleAltText: snippet[0].snippet
                                }, function () {
                                    document.getElementById("toggleSearchLabel").innerHTML = _this.state.searchToggleAltText;
                                });
                            }
                        });
                        window.addEventListener('resize', function () {
                            _this.setWorkspaceSize();
                            clearTimeout(delayResizeEvent);
                            delayResizeEvent = setTimeout(_this.onComponentResize, 100);
                        });
                        // we call onComponentResize() initially when the component first loads, after waiting a few seconds for the rest of the page to load
                        setTimeout(this.onComponentResize, 1000);
                        // set search tabindex if it's loaded
                        setTimeout(function () { return _this.searchTabindexScript(0); }, 1000);
                        if (this.heightListener) {
                            this.heightListener.contentWindow.addEventListener('resize', function () {
                                _this.setWorkspaceSize();
                                _this.onComponentResize();
                            });
                        }
                        // add click events
                        document.addEventListener('click', this.handleClick, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Loop through buttons and inputs in the header search web part and set tab index
     * @param state
     * "0" = show everything (tabIndex=0)
     * "-1" = hide everything (taxIndex=-1)
     */
    Header.prototype.setSearchTabIndex = function (state) {
        var searchFocusElements = document.querySelectorAll("#searchWrapper button, #searchWrapper input");
        for (var i = 0; i < searchFocusElements.length; i++) {
            searchFocusElements[i].setAttribute("tabIndex", state);
        }
        // if open, set focus to the first button
        if (state == "0") {
            var firstButton = searchFocusElements[0];
            firstButton.focus();
        }
    };
    Header.prototype.searchTabindexScript = function (numOfTries) {
        if (document.querySelector("#searchWrapper .searchbox-webpart")) {
            this.setSearchTabIndex("-1");
        }
        else {
            window.setTimeout(function () {
                if (numOfTries < 5) {
                    this.searchTabindexScript(numOfTries + 1);
                }
            }, 1000);
        }
    };
    Header.prototype.onComponentResize = function () {
        // set workspace
        this.setWorkspaceSize();
        // console.log("on resize");
        this.markScroll();
        var mobileBreakpoint = 767; // max
        var tabletBreakpoint = 1219; // new number for wider menu 991; // max
        var smallerThanMobileBreakpoint = document.documentElement.clientWidth <= mobileBreakpoint ? true : false;
        // var biggerThanMobileBreakpoint: boolean = window.innerWidth > mobileBreakpoint ? true: false;
        var smallerThanTabletBreakpoint = document.documentElement.clientWidth <= tabletBreakpoint ? true : false;
        // move search button to the right DOM location
        var headerWrapper = document.getElementById("headerWrapper");
        var mainHeader = document.getElementById("mainHeader");
        var headerNav = document.getElementById("headerNav");
        var searchWrapper = document.getElementById("searchWrapper");
        if (headerWrapper && headerNav && mainHeader && searchWrapper) {
            // headerNav.remove();
            var cutHeader = headerNav.parentElement.removeChild(headerNav);
            if (this.state.isTablet) {
                mainHeader.appendChild(cutHeader);
            }
            else {
                headerWrapper.insertBefore(cutHeader, searchWrapper);
            }
        }
        var headerWrapper = document.getElementById("header");
        if (window.innerWidth < (tabletBreakpoint + 1)) {
            document.querySelector("html").classList.add("isMobile");
            // var headerWidth = (window.innerWidth - this.scrollBarWidth) + 'px';
            // var headerLeft = "calc(50% - " + this.scrollBarWidth/2 + "px)";
            // headerWrapper.style.width = headerWidth;
            // headerWrapper.style.left = headerLeft;
        }
        else {
            document.querySelector("html").classList.remove("isMobile");
            // headerWrapper.style.width = "100%";
            // headerWrapper.style.left = "inherit";
        }
        this.setState({
            isMobile: smallerThanMobileBreakpoint,
            isTablet: smallerThanTabletBreakpoint,
            // componentWidth: this.parentRef.offsetWidth,
            componentWidth: document.getElementById("s4-bodyContainer").clientWidth,
            componentHeight: document.getElementById("s4-workspace").clientHeight,
            meganavOpen: false
        });
    };
    Header.prototype.componentWillUnmount = function () {
        var _this = this;
        // remove the resize listener when this component is unmounted
        window.removeEventListener('resize', function () {
            _this.onComponentResize();
        });
        // document.getElementById('s4-workspace').removeEventListener('scroll', this.hideHeader);
        this._isMounted = false;
        this.markRibbon(false);
    };
    Header.prototype.render = function () {
        // let spContext: any = window["_spPageContextInfo"];
        var _this = this;
        // set width for fixed header
        // if( window.innerWidth < 1310){
        //     this.headerStyle = {
        //         width: (window.innerWidth - this.scrollBarWidth) + 'px',
        //         left: "calc(50% - " + this.scrollBarWidth/2 + "px)"
        //     }
        // } else {
        //     this.headerStyle = {
        //         width: '1280px',
        //         left: "calc(50% - " + this.scrollBarWidth/2 + "px)"
        //     }
        // }
        // calculate mobile dropdown size and placement;
        var mobilePanelTopOffset = 48; // TODO: make this dynamic, based on height of mobile header
        // console.log("mobilePanelTopOffset: " + mobilePanelTopOffset);
        var mobilePanelHeight = this.state.componentHeight - mobilePanelTopOffset;
        if (this.state.isTablet && this.state.isMobile) {
            // if mobile nav, we have to set the width and height of the mobile nav dropdown
            this.mobileNavPanelStyle = {
                width: this.state.componentWidth + 'px',
                height: mobilePanelHeight + 'px'
                // top: (document.getElementById('ms-designer-ribbon').clientHeight + 53) + 'px'
            };
        }
        else if (this.state.isTablet && !this.state.isMobile) {
            this.mobileNavPanelStyle = {
                width: '320px',
                height: mobilePanelHeight + 'px'
                // top: (document.getElementById('ms-designer-ribbon').clientHeight + 53) + 'px'
            };
        }
        else {
            this.mobileNavPanelStyle = {};
            mobilePanelHeight = this.state.componentHeight - 137;
        }
        if (!this.state.isTablet) {
            return (React.createElement("div", { id: "meganavDesktop" },
                React.createElement(Meganav, { tabIndexCallback: function (level, hide, element) { return _this.setTabIndex(level, hide, element); }, sliderFirstHidden: this.state.sliderFirstHidden, sliderSecondHidden: this.state.sliderSecondHidden, componentHeight: mobilePanelHeight, componentWidth: this.state.componentWidth, isTablet: this.state.isTablet })));
        }
        else {
            return (React.createElement(React.Fragment, null, this.state.meganavOpen && (React.createElement("div", { id: "mobileNav", style: this.mobileNavPanelStyle },
                React.createElement("div", { id: "mobileNavContainer" }, this.state.isTablet && React.createElement(Meganav, { tabIndexCallback: function (level, hide, element) { return _this.setTabIndex(level, hide, element); }, sliderFirstHidden: this.state.sliderFirstHidden, sliderSecondHidden: this.state.sliderSecondHidden, componentHeight: mobilePanelHeight, componentWidth: this.state.isMobile ? this.state.componentWidth : 320, isTablet: this.state.isTablet }))))));
        }
    };
    // @level: 1 or 2 (which level is being hidden)
    // @hide: true = hidden, false = no longer hidden
    // @element: which element to refocus on when returning
    Header.prototype.setTabIndex = function (level, hide, element) {
        // console.log("setTabIndex", level)
        if (level == 1) {
            this.setState({
                sliderFirstHidden: hide
            });
        }
        if (level == 2) {
            this.setState({
                sliderSecondHidden: hide
            });
        }
        if (!hide && element) {
            if (document.getElementById(element)) {
                document.getElementById(element).focus();
            }
        }
    };
    return Header;
}(React.Component));
export { Header };
